module.exports = __webpack_public_path__ + "img/yesIcon.cae8a58c.png";